import { useQuery } from '@tanstack/react-query';

import { LanguageKey } from '@models/Language';
import { RealEstateDocument } from '@models/realEstate.types';
import { fetchParkingProductsQuery } from '@stores/parking.queries';

/** Fetches all parking products for the real estate */
export const useParkingProducts = (
  realEstate: RealEstateDocument | undefined,
  language: LanguageKey
) => {
  const queryOptions = fetchParkingProductsQuery(realEstate, language);
  const { isLoading, ...rest } = useQuery(queryOptions);

  return {
    ...rest,
    // if query is disabled `isLoading` is true by default
    isLoading: queryOptions.enabled && isLoading,
  };
};
